import $ from 'jquery';

const email = {
  subject: 'Check it out!',
  body: `Hi, I found this website and thought you might like it. ${window.location}`,
  btnText: 'Email to a friend',
};

function EmailBtn(element) {
  const mailto = `mailto:?subject=${email.subject}&body=${email.body}`;
  $(element).append(`<li><a class="social social-email" href="${mailto}" target="_blank">${email.btnText}</a></li>`);
}

export default EmailBtn;



// WEBPACK FOOTER //
// ./EmailBtn.js